module.exports = __webpack_public_path__ + "static/media/cases_brand_jardim_06.5240f76e.jpg";